import React from 'react';
import { useAuth } from '../hooks';

// Simple component to demonstrate AuthContext usage
export const AuthStatus: React.FC = () => {
  const { user, isAuthenticated, isLoading, error, logout } = useAuth();

  if (isLoading) {
    return <div>Loading authentication status...</div>;
  }

  if (error) {
    return <div style={{ color: 'red' }}>Error: {error}</div>;
  }

  if (isAuthenticated && user) {
    return (
      <div>
        <p>Welcome, {user.email}!</p>
        <p>Role: {user.role}</p>
        <button onClick={logout}>Logout</button>
      </div>
    );
  }

  return (
    <div>
      <p>Not authenticated</p>
      <p>Please log in to continue</p>
    </div>
  );
};

export default AuthStatus;
